import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/stealth-ai-writer")({
  staticData: {
    title: "Stealth AI",
  },
  head: () => ({
    meta: [
      {
        name: "description",
        content:
          "Generate AI-driven content without detectable traces using Polygraf AI’s Stealth AI Writer - live internet access, citations, exportable drafts, and local or on-premises governance.",
      },
    ],
  }),
});
